var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShare2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.158 5.25432L7.84025 3.41319M7.84201 8.58769L4.16322 6.74829M11 2.66667C11 3.58714 10.2538 4.33333 9.33333 4.33333C8.41286 4.33333 7.66667 3.58714 7.66667 2.66667C7.66667 1.74619 8.41286 1 9.33333 1C10.2538 1 11 1.74619 11 2.66667ZM4.33333 6C4.33333 6.92047 3.58714 7.66667 2.66667 7.66667C1.74619 7.66667 1 6.92047 1 6C1 5.07953 1.74619 4.33333 2.66667 4.33333C3.58714 4.33333 4.33333 5.07953 4.33333 6ZM11 9.33333C11 10.2538 10.2538 11 9.33333 11C8.41286 11 7.66667 10.2538 7.66667 9.33333C7.66667 8.41286 8.41286 7.66667 9.33333 7.66667C10.2538 7.66667 11 8.41286 11 9.33333Z",
    stroke: "#BBBBBB"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare2);
export default __webpack_public_path__ + "static/media/share2.031c048ecf11feb3f5f67ef33de56c12.svg";
export { ForwardRef as ReactComponent };